module.exports = __webpack_public_path__ + "static/x44-556391530f7177e80c9bbca29979ad7b.png";